import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { AdverseEffect } from "../../Apis/AuthApiServices";
import useFetch from "../../CustomHooks/useFetch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { AdverseEffectsStyle } from "../../Theme";

export default function AdverseEffectPOPUp(props: any) {
  const params = {
    drugId: props?.drugIdforadverse,
  };
  const { data, loading, error }: any = useFetch(params, AdverseEffect, []);

  if (error)
    return (
      <>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={12}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Something went wrong!
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  return (
    <>
      {loading ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"50vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <AdverseEffectsStyle>
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} md={12}>
              <Typography
                component={"div"}
                variant={"subtitle1"}
                color={"primary"}
                fontWeight={700}
              >
                {data[0]?.drugname}
              </Typography>

              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 350 }} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        {" "}
                        <Typography
                          component={"div"}
                          variant={"subtitle2"}
                          fontWeight={700}
                        >
                          Major Severity:
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>{" "}
                  <TableBody>
                    {data[0]?.majorSeverityEffects?.map((each: any) => (
                      <>
                        <TableRow key={each?.effectName}>
                          <TableCell component="th" scope="row">
                            <Typography
                              component={"div"}
                              fontWeight={600}
                              color={"primary"}
                            >
                              {each?.effectName}{" "}
                              <Typography
                                component={"span"}
                                fontWeight={400}
                                style={{ color: "#333" }}
                              >
                                ({each?.classification})
                              </Typography>
                            </Typography>
                            <Typography
                              component={"div"}
                              variant={"body2"}
                              fontWeight={400}
                              margin={"3px 0 6px"}
                            >
                              {each?.effectDescription}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}{" "}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>{" "}
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 350 }} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        {" "}
                        <Typography
                          component={"div"}
                          variant={"subtitle2"}
                          fontWeight={700}
                        >
                          Moderate Severity:
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>{" "}
                  <TableBody>
                    {data[0]?.moderateSeverityEffects?.map((each: any) => (
                      <>
                        <TableRow key={each?.effectName}>
                          <TableCell component="th" scope="row">
                            <Typography
                              component={"div"}
                              fontWeight={600}
                              color={"primary"}
                            >
                              {each?.effectName}{" "}
                              <Typography
                                component={"span"}
                                fontWeight={400}
                                style={{ color: "#333" }}
                              >
                                ({each?.classification})
                              </Typography>
                            </Typography>
                            <Typography
                              component={"div"}
                              variant={"body2"}
                              fontWeight={400}
                              margin={"3px 0 6px"}
                            >
                              {each?.effectDescription}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}{" "}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>{" "}
            <Grid item xs={12} md={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 350 }} aria-label="caption table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        {" "}
                        <Typography
                          component={"div"}
                          variant={"subtitle2"}
                          fontWeight={700}
                        >
                          Minor Severity:
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableHead>{" "}
                  <TableBody>
                    {data[0]?.minorSeverityEffects?.map((each: any) => (
                      <>
                        <TableRow key={each?.effectName}>
                          <TableCell component="th" scope="row">
                            <Typography
                              component={"div"}
                              fontWeight={600}
                              color={"primary"}
                            >
                              {each?.effectName}{" "}
                              <Typography
                                component={"span"}
                                fontWeight={400}
                                style={{ color: "#333" }}
                              >
                                ({each?.classification})
                              </Typography>
                            </Typography>
                            <Typography
                              component={"div"}
                              variant={"body2"}
                              fontWeight={400}
                              margin={"3px 0 6px"}
                            >
                              {each?.effectDescription}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}{" "}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </AdverseEffectsStyle>
      )}
    </>
  );
}
